import { CaretDownOutlined, CaretUpOutlined, CheckOutlined, HomeOutlined, LeftOutlined, MailOutlined, ReloadOutlined } from '@ant-design/icons';
import { routeHistory } from '@nackle/biw-web-router';
import { Button, Card } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { Routes } from '../../routes';
import { reportError } from '../../updated/utils';
import './styles.less';

const status = {
    SUBMITTED: 'submitted',
    IDLE: 'idle',
    IN_PROCESS: 'in process'
};

/* put this component anywhere on the page and feed it the errors it might recieve */
export const ErrorPopup = ( { errors, overrideMessage } ) => {
    const isVisible = useMemo( () => errors.some( e => !!e ), [ errors ] );

    const [ contextEnabled, setContextEnabled ] = useState( false );
    const [ submitStatus, setSubmitStatus ] = useState( status.IDLE );
    const [ context, setContext ] = useState( '' );

    function getErrorMessage( error ) {
        if ( typeof error === 'object' && !Array.isArray( error ) ) {
            return [
                error.message,
                error.networkError?.name,
                ...( error.networkError?.result?.errors?.map( e => JSON.stringify( e, null, 4 ) ) ?? [] ),
                ...( error.graphQLErrors?.map( e => JSON.stringify( e, null, 4 ) ) ?? [] ),
            ].filter( e => !!e ).join( '\n' );
        } else if ( typeof error === 'object' ) {
            // error is array
            return error.map( e => getErrorMessage( e ) );
        }

        return error;
    }

    function refresh() {
        window.location.reload();
    }

    function home() {
        routeHistory.push( Routes.Home.buildPath() );
    }

    function back() {
        routeHistory.back();
    }

    function report() {
        setSubmitStatus( status.IN_PROCESS );
        reportError( [
            `-----  Message from user -----`, context,
            `------------- URL ------------`, window.location.href,
            `----------- Errors -----------`, errors.filter( e => !!e ).map( e => getErrorMessage( e ) ).join( '------------------------------\n' ),
        ].join( '\n\n' ) )
            .then( () => {
                setSubmitStatus( status.SUBMITTED );
            } );
    }

    return (
        <div className={ classNames( 'error-overlay', { visible: isVisible === true } ) }>
            <Card className='error-popup' title='Oops!' actions={ [
                <Button key='back' onClick={ back }>
                    <LeftOutlined /> Back
                </Button>,
                <Button key='refresh' onClick={ refresh }>
                    <ReloadOutlined /> Refresh
                </Button>,
                <Button key='home' onClick={ home }>
                    <HomeOutlined /> Home
                </Button>
            ] }>


                <p>{ overrideMessage || 'We\'ve encountered an error and can\'t load the page.' }</p>
                <p className='prompt' onClick={ () => setContextEnabled( !contextEnabled ) } >Help us fix this issue by informing the development team? { contextEnabled ? <CaretUpOutlined /> : <CaretDownOutlined /> }</p>
                <div className={ classNames( 'context', { visible: contextEnabled } ) }>
                    <TextArea 
                        placeholder='What were you doing when this problem happened?' 
                        onChange={ ( e ) => setContext( e.target.value ) } value={ context } 
                        autoSize={ { minRows: 3, maxRows: 5 } }/>
                    <Button 
                        loading={ submitStatus === status.IN_PROCESS } 
                        onClick={ () => report() }> { submitStatus === status.SUBMITTED ? <><CheckOutlined/> Sent</> : <><MailOutlined/> Submit</> }</Button>
                </div>

                
            </Card>
        </div>
    );
};